import CryptoJS from "crypto-js";
import Base64 from "base-64";

const AES_IMAGE_SECRET_KEY = process.env.REACT_APP_AES_IMAGE_SECRET_KEY;

// =================================================

/**
 * Decrypts an encrypted URL using AES and Base64.
 * @param {string} encryptedUrl - The encrypted URL.
 * @param {string} secretKey - The AES key (must be 16 characters for AES-128).
 * @returns {string|null} - The decrypted URL, or null if decryption fails.
 */

// export default function decryptUrl(
//   encryptedUrl,
//   secretKey = AES_IMAGE_SECRET_KEY
// ) {
//   try {
//     // Base64 decode the encrypted URL
//     const encryptedBytes = Base64.decode(encryptedUrl);

//     // Convert to WordArray for CryptoJS
//     const encryptedWordArray = CryptoJS.enc.Hex.parse(
//       CryptoJS.enc.Base64.parse(encryptedUrl).toString(CryptoJS.enc.Hex)
//     );

//     // Decrypt using AES with ECB mode and PKCS5 padding
//     const decryptedBytes = CryptoJS.AES.decrypt(
//       { ciphertext: encryptedWordArray },
//       CryptoJS.enc.Utf8.parse(secretKey),
//       {
//         mode: CryptoJS.mode.ECB,
//         padding: CryptoJS.pad.Pkcs7,
//       }
//     );

//     // Convert decrypted bytes to a UTF-8 string
//     const decryptedUrl = decryptedBytes.toString(CryptoJS.enc.Utf8);
//     return decryptedUrl;
//   } catch (error) {
//
//     return null;
//   }
// }

// ====================================================================

// Function to convert hex key to a WordArray (needed for CryptoJS)
const hexStringToWordArray = (hexString) => {
  return CryptoJS.enc.Hex.parse(hexString);
};

// Function to decrypt URL
const decryptUrl = (encryptedUrl, key = AES_IMAGE_SECRET_KEY) => {
  if (!encryptedUrl) {
    return null;
  }

  try {
    // Convert the hex key to a WordArray
    const keyBytes = hexStringToWordArray(key);

    // Base64 decode the encrypted URL
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedUrl);

    // Decrypt the data using AES
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes },
      keyBytes,
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    );

    // Convert the decrypted data to a UTF-8 string
    const decryptedUrl = decrypted.toString(CryptoJS.enc.Utf8);

    return decryptedUrl;
  } catch (error) {
    return null;
  }
};

//decryptUrl fucntion for jio cloud
export const decryptUrl2 = (encryptedUrl) => {
  if (!encryptedUrl) {
    return null;
  }
  return encryptedUrl;
};
export default decryptUrl;

// ====================================================================

// const hexStringToWordArray = (hexString) => {
//   return CryptoJS.enc.Hex.parse(hexString);
// };

// // Function to decrypt URL
// const decryptUrl = (encryptedUrl, key = "b64035dfd6ee7c8d70b545bab7e8fef4") => {
//   if (!encryptedUrl) {
//
//     return null;
//   }

//   try {
//

//     // Convert the hex key to a WordArray
//     const keyBytes = hexStringToWordArray(key);

//     // Decrypt the data using AES
//     const decrypted = CryptoJS.AES.decrypt(encryptedUrl, keyBytes, {
//       mode: CryptoJS.mode.ECB,
//       padding: CryptoJS.pad.Pkcs7,
//     });

//     // Convert the decrypted data to a UTF-8 string
//     const decryptedUrl = decrypted.toString(CryptoJS.enc.Utf8);
//
//     return decryptedUrl;
//   } catch (error) {
//
//     return null;
//   }
// };

// export default decryptUrl;
